module.exports = __webpack_public_path__ + "img/net03.cf633d27.jpg";